import React, { useState, Fragment } from 'react';

import './MapboxComponent.css';
import _ from 'lodash';
import mapboxgl from 'mapbox-gl';
import { connect } from 'react-redux';

import 'mapbox-gl/dist/mapbox-gl.css';

import Map from './BaseMap';
// import Map from './Map';
import DisplayLocations from './DisplayLocations';
import ProviderLocationTable from './ProviderLocationTable';

import rightArrow from '../../assets/img/rightArrow.svg';
import { CUSTOM_CLIENT_NAME } from '../../models/headers';
import * as actionTypes from '../../store/actions/index';
import { getDistance, scrollClickHandler } from '../../utils/utils';

function MapboxComponent(props) {
  let popup;

  const { optionData, allData, currentDeal } = props;
  const surveyData = allData.survey;

  const [data, setData] = useState([]);
  const [map, setMap] = useState();

  const locations = [];

  allData.optionProviderRequestList = _.orderBy(
    allData?.optionProviderRequestList,
    'optionOrder',
    'asc',
  );

  if (allData && allData?.optionProviderRequestList) {
    allData?.optionProviderRequestList?.forEach(function (opt) {
      const address = opt && opt.address && opt.address;
      const lng = address && address.lng;
      const lat = address && address.lat;

      if (lng != null && lat != null) {
        const unitVal =
          opt &&
          opt.availableSpaceList &&
          opt.availableSpaceList.length > 0 &&
          opt.availableSpaceList[0] != null &&
          opt.availableSpaceList[0].unit;

        locations.push({
          name: opt.optionName,
          id: opt.optionOrder,
          optionId: opt.id,
          coordinates: [lng, lat],
          unit: unitVal ? unitVal : '',
        });
      }
    });
  }

  const setValues = (value) => {
    if (value === 'cancel') {
      setData([]);
    } else {
      setData((prevValues) => {
        return [value, ...prevValues];
      });
    }
  };

  const setMapHandler = (map) => {
    if (map) {
      setMap(map);
    }
  };

  function flyToStore(coordinates) {
    if (map) {
      map.flyTo({
        center: coordinates,
        zoom: 14,
        speed: 2,
      });
    }
  }

  function addPopup(val) {
    if (map) {
      if (val.unit) {
        popup = new mapboxgl.Popup({ closeOnClick: true, closeButton: false })
          .setLngLat(val.coordinates)
          .setHTML(val.name + '<br/> unit ' + val.unit)
          .addTo(map);
      } else {
        popup = new mapboxgl.Popup({ closeOnClick: true, closeButton: false })
          .setLngLat(val.coordinates)
          .setHTML(val.name)
          .addTo(map);
      }
    }
  }

  const addPopupToCurrent = (coordinates, name) => {
    if (map) {
      popup = new mapboxgl.Popup({
        closeOnClick: true,
        closeButton: false,
        className: 'currentPopup',
      })
        .setLngLat(coordinates)
        .setHTML(name)
        .addTo(map);
    }
  };
  const zval = 1;
  const selectedId = 0;
  const remove = () => {
    if (popup) {
      popup.remove();
    }
  };

  const currentHoverHandler = () => {
    const latLng = props.latLong;
    const currentLoc = props.clientCurrentLocation;

    if (latLng) {
      flyToStore(latLng);

      addPopupToCurrent(latLng, currentLoc);
    }
  };

  const hoverHandler = (hoveredEl) => {
    flyToStore(hoveredEl.coordinates);

    addPopup(hoveredEl);
  };
  const chkDuplicate = (array, value) => {
    let n = 0;

    for (let i = 0; i < array.length; i++) {
      if (array[i].name == value) {
        n++;
      }
    }

    return n;
  };

  return (
    <div className="optionDetails">
      <div className="leftHalf">
        <h1
          // eslint-disable-next-line
          align="left"
          style={{
            padding: '30px',
            width: '105%',
            fontSize: '34px',
            color: '#1A1A1A',
          }}
          id="mapBoxPageH1"
        >
          {props?.currentDeal['Target Market'] && (
            <span style={{ textTransform: 'capitalize' }}>
              {props?.currentDeal['Target Market']}
            </span>
          )}{' '}
          Agile Options
        </h1>
        <div
          style={{
            backgroundColor: 'rgb(248, 248, 248)',
            margin: '20px',
            height: '75vh',
          }}
        >
          {/* <Map optionData={optionData} setValuesSource={setValues}/> */}

          <Map
            optionData={optionData}
            setValuesSource={setValues}
            setMap={(map) => setMapHandler(map)}
          />
        </div>
      </div>
      <div className="rightHalf">
        <div className="locationPanel">
          <DisplayLocations currentLocHovered={currentHoverHandler} remove={remove} />
          {/* <ProviderLocationTable /> */}
          <div className="mapbox-table-container">
            <table className="mapbox-provider-table">
              <thead className="provider-table-head">
                <tr>
                  <th className="table-provider-options">Option</th>
                  {props.latLong.length > 0 && (
                    <th className="table-provider-distance">Distance</th>
                  )}
                  <th style={{ width: '10%' }}></th>
                </tr>
              </thead>
              <tbody className="provider-table-body">
                {locations?.map((location, index) => (
                  <tr key={index} onMouseEnter={() => hoverHandler(location)} onMouseLeave={remove}>
                    <td className="table-provider-options">
                      <div>
                        <span className="marker__icon">{index + 1}</span>
                        <span style={{ display: 'table-cell' }}>{location.name}</span>
                      </div>
                    </td>

                    {props.latLong.length > 0 && (
                      <td className="table-provider-distance">
                        {currentDeal?.['Client Name']?.[0].toLowerCase() ===
                        CUSTOM_CLIENT_NAME.toLocaleLowerCase()
                          ? getDistance(location.coordinates, props.latLong, 'km')
                          : getDistance(location.coordinates, props.latLong, 'miles')}
                      </td>
                    )}
                    <td
                      title="View Option Details"
                      onClick={() => scrollClickHandler(location.optionId)}
                      style={{ cursor: 'pointer' }}
                      className="provider-details"
                    >
                      <svg
                        style={{ transform: 'scale(1.5)' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="none"
                        viewBox="0 0 12 12"
                      >
                        <path
                          fill="#003F2D"
                          d="M1.705 0L.295 1.41 4.875 6l-4.58 4.59L1.705 12l6-6-6-6z"
                        ></path>
                      </svg>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allData: state.optRed.data,
    locations: state.locRed.rows,
    displayDate: state.comRed.displayDate,
    latLong: state.comRed.latLong,
    clientCurrentLocation: state.comRed.displayCurrentLocation,
    currentDeal: state.comRed.currentDeal,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLocations: (locations) => dispatch(actionTypes.locationAction(locations)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapboxComponent);
